const BASE_IP = "https://meetsofie.com/";

export const API_URL = BASE_IP + "api/";

export const SERVER_URL = BASE_IP;

// Replace with your actual Google OAuth Client ID
export const GOOGLE_CLIENT_ID = "YOUR_GOOGLE_CLIENT_ID_HERE";